<fieldset *ngIf="!detailViewComponent.smallScreen; else stacked">
  <div class="form-group row">
    <label class="col-form-label col-5 text-right" [class.required]="prop.field_required">
      {{ prop.field_label | translate }}
    </label>
    <div class="col-7">
      <input type="text" bsDatepicker class="form-control form-control-sm datepicker-sm"
             [name]="prop.field_name"
             [readonly]="!prop.field_editable"
             [formControl]="graphicFormGroup.controls[prop.field_name]"
             [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY', containerClass: cssTheme, container: 'body', adaptivePosition: true }"
      />
      <error-tooltip [errorMessages]="errorMessages"></error-tooltip>
    </div>
  </div>
</fieldset>

<ng-template #stacked>
  <fieldset>
    <div class="form-group">
      <label class="col-form-label" [class.required]="prop.field_required">
        {{ prop.field_label | translate }}
      </label>
      <input type="text" bsDatepicker class="form-control form-control-sm datepicker-sm"
             [name]="prop.field_name"
             [readonly]="!prop.field_editable"
             [formControl]="graphicFormGroup.controls[prop.field_name]"
             [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY', containerClass: cssTheme, container: 'body', adaptivePosition: true }"
      />
      <error-tooltip [errorMessages]="errorMessages"></error-tooltip>
    </div>
  </fieldset>
</ng-template>

